export interface PrestadorForm {
  cnpj?: string;
  nome: string;
  grupo_economico?: string;          // legado (texto livre)
  grupo_economico_cnpj?: string;     // FK p/ grupo_economico (CNPJ da empresa principal)
  grupo_economico_nome?: string;     // só p/ exibição
  is_anga: boolean;
  papeis: string[];                  // papéis que o prestador pode exercer (catálogo papel_prestador)
}

export interface PrestadorListItem {
  id: number;
  cnpj: string;
  nome: string;
  grupo_economico: string;       // nome do grupo (FK) com fallback p/ o texto legado
  grupo_economico_cnpj: string;
  is_anga: boolean;
  qtd_fundos: number;
}

export interface GrupoEconomico {
  cnpj: string;
  nome: string;
}

export interface FundoVinculo {
  id: number;
  fundo_id: number;
  papel: string;
  data_inicio?: string;
  data_fim?: string;
  razao_social: string;
  nome_fantasia?: string;
  fundo_cnpj: string;
}

export interface PrestadorDetalhe {
  id: number;
  form: PrestadorForm;
  fundos: FundoVinculo[];
}

export const prestadorVazio = (): PrestadorForm => ({ nome: '', is_anga: false, papeis: [] });
